module.exports = __webpack_public_path__ + "static/RadovanKubovič-dc3ae027977d915932fa8b63e98426c7.jpg";